import Error404 from "./Error404";
import DocumentError404 from "./DocumentError404";

export default Error404;
export { DocumentError404 };



// WEBPACK FOOTER //
// ./src/components/ErrorComponents/index.js